export default __webpack_public_path__ + "media/images/mailer/wordmark-742de75a15a2d58d5962680eee83319a.png";